var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('path', {
      attrs: {
        "d": "M58.15 59.08H46.126a.921.921 0 01-.93-.908v-6.475a.921.921 0 01.93-.908h12.022c.508-.005.924.4.93.908v6.475a.921.921 0 01-.93.908zm-8.763-27.773c1.274 1.523 1.485 3.36 1.316 4.226-.241 1.26-.34 2.884-.27 3.198.018.047.037.096.057.143.188.455.32.94.036 2.275-.325 1.515-.833 2.306-1.203 2.709a9.28 9.28 0 01-.814 2.6c-.288.573-.583 1.002-.583 1.673 0 .808.032.821.24.882.681.188 1.482.423 2.315.678h-4.448c-1.168 0-2.115.935-2.115 2.085v7.22H30.48c-1.161 0-1.481-.865-1.481-1.37v-3.568c0-.77.291-1.626 1.481-2.101 1.503-.617 5.535-1.974 8.066-2.672.195-.06.229-.07.229-.882 0-.872-.107-1.49-.337-1.945a9.28 9.28 0 01-.815-2.6c-.373-.403-.878-1.194-1.204-2.711-.285-1.331-.15-1.818.038-2.273.02-.049.04-.098.056-.149.072-.308-.028-1.93-.272-3.192-.17-.867.041-2.705 1.316-4.226.81-.965 2.353-2.143 5.123-2.307h1.54c2.818.162 4.357 1.342 5.166 2.307zM47.78 56.442a.566.566 0 00-.573.56c0 .309.257.559.573.559h8.45a.566.566 0 00.574-.558.566.566 0 00-.573-.559h-8.45v-.002zm0-2.226a.566.566 0 00-.573.56c0 .31.257.56.573.56h8.45a.566.566 0 00.574-.56.566.566 0 00-.573-.56h-8.45zm0-2.222a.566.566 0 00-.573.559c0 .308.257.558.573.558h3.151a.564.564 0 00.573-.558.564.564 0 00-.573-.559h-3.15z",
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};